import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const Section = ({ id, title, children }) => (
  <section data-testid={`legal-section-${id}`} className="space-y-2">
    <h2 className="font-heading text-lg font-semibold text-slate-900">{title}</h2>
    <div className="space-y-2 text-[15px] leading-relaxed text-slate-700">{children}</div>
  </section>
);

export default function LegalPage() {
  const year = new Date().getFullYear();
  return (
    <div className="min-h-screen bg-slate-50 font-body px-4 py-10">
      <article data-testid="legal-page" className="mx-auto max-w-3xl rounded-2xl border border-slate-200 bg-white p-6 sm:p-10 space-y-8">
        <Link to="/login" data-testid="legal-back-link" className="inline-flex items-center gap-1 text-sm font-semibold text-primary hover:underline"><ArrowLeft className="h-4 w-4" /> Torna a Insieme</Link>
        <header className="flex items-center gap-4">
          <img src="/logo-insieme.png" alt="Logo Insieme" className="h-16 w-16 object-contain" />
          <div>
            <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">Privacy e note legali</h1>
            <p className="text-slate-500 mt-1">Applicazione Insieme · Opale Group</p>
          </div>
        </header>

        <Section id="publisher" title="1. Editore e titolare del servizio">
          <p data-testid="legal-company">Opale Group<br />6984 Pura, Svizzera<br />E-mail: <a className="text-primary underline" href="mailto:info@opale-group.ch">info@opale-group.ch</a></p>
          <p>Numero IDI/UID: [da completare]</p>
        </Section>

        <Section id="scope" title="2. Ambito">
          <p>Insieme è una piattaforma per la gestione delle associazioni (inventario, entrate e uscite, fatture, eventi, sale e prenotazioni, compiti, lista della spesa, rimborsi spese). La presente informativa è redatta secondo la Legge federale sulla protezione dei dati (nLPD) e la relativa ordinanza (OPDa).</p>
          <p>Ogni associazione che usa Insieme è titolare dei dati dei propri membri, clienti e richiedenti. Opale Group tratta questi dati per conto dell'associazione, unicamente per fornire il servizio.</p>
        </Section>

        <Section id="data" title="3. Dati trattati">
          <ul className="list-disc pl-5 space-y-1">
            <li>Dati dell'account: nome, nome utente, e-mail, password (salvata solo in forma cifrata), ruolo nell'associazione.</li>
            <li>Dati operativi inseriti dagli utenti: prodotti, lotti, movimenti, eventi, compiti, prenotazioni, commenti.</li>
            <li>Dati di fatturazione: intestatario, indirizzo, e-mail, importi e righe delle fatture.</li>
            <li>Rimborsi spese: importi, descrizioni e giustificativi caricati (es. scontrini).</li>
            <li>Richieste dal modulo pubblico di prenotazione: nome, contatti, data e dettagli della richiesta.</li>
            <li>Dati tecnici: indirizzo IP, registro delle attività, iscrizioni alle notifiche push del dispositivo.</li>
          </ul>
        </Section>

        <Section id="purpose" title="4. Finalità">
          <p>I dati sono usati solo per far funzionare il servizio: accesso sicuro, gestione dell'associazione, invio di fatture, notifiche ed e-mail di servizio, sicurezza e prevenzione degli abusi. Non vendiamo i dati e non li usiamo per pubblicità.</p>
        </Section>

        <Section id="processors" title="5. Fornitori e luogo di trattamento">
          <p>Le e-mail vengono inviate tramite Infomaniak (Svizzera). Le notifiche push passano dal servizio del produttore del browser o del dispositivo (ad es. Google, Apple, Mozilla), che riceve soltanto il testo della notifica.</p>
          <p>Hosting dell'applicazione e del database: [da completare]</p>
        </Section>

        <Section id="retention" title="6. Conservazione">
          <p>I dati restano salvati finché l'associazione usa il servizio, o finché lo richiede la legge (ad es. 10 anni per i documenti contabili secondo l'art. 958f CO). I dati eliminati in modo logico possono essere ripristinati dagli amministratori dell'associazione.</p>
        </Section>

        <Section id="rights" title="7. I tuoi diritti">
          <p>Puoi chiedere informazioni sui tuoi dati, la loro rettifica o cancellazione e la consegna in un formato elettronico. Scrivi all'amministratore della tua associazione oppure a <a className="text-primary underline" href="mailto:info@opale-group.ch">info@opale-group.ch</a>. Puoi anche rivolgerti all'Incaricato federale della protezione dei dati e della trasparenza (IFPDT).</p>
        </Section>

        <Section id="cookies" title="8. Cookie e memoria locale">
          <p>Usiamo solo cookie tecnici, necessari per mantenere l'accesso in modo sicuro, e la memoria locale del browser per ricordare l'associazione selezionata e alcune preferenze. Non usiamo cookie di profilazione o di analisi.</p>
        </Section>

        <Section id="security" title="9. Sicurezza">
          <p>I dati di ogni associazione sono separati da quelli delle altre. Gli accessi sono protetti, le password sono cifrate e i permessi vengono controllati sul server in base al ruolo.</p>
        </Section>

        <Section id="legal" title="10. Note legali">
          <p>Tutti i contenuti, il marchio Insieme e il software sono di Opale Group, salvo diversa indicazione. Senza autorizzazione scritta non è consentito copiarli o riutilizzarli.</p>
          <p>Opale Group cura con attenzione il servizio, ma non garantisce che sia sempre disponibile e senza errori. Ogni associazione è responsabile dei dati che inserisce e dei documenti, come le fatture, che emette tramite Insieme.</p>
          <p>Si applica il diritto svizzero. Foro competente: [da completare].</p>
        </Section>

        <footer className="pt-4 border-t border-slate-200 text-sm text-slate-500">Ultimo aggiornamento: ottobre 2026 · © {year} Opale Group</footer>
      </article>
    </div>
  );
}
